import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFaceId: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 23.62H32v4.57h-1.53Zm0-10.67H32v6.1h-1.53Zm0-9.14H32v4.57h-1.53Zm-1.52 24.38h1.52v1.52h-1.52Zm0-25.91h1.52v1.53h-1.52ZM24.38.76h4.57v1.52h-4.57Zm0 28.95h4.57v1.53h-4.57Zm-3.05-9.14h1.52v1.52h-1.52Zm0-12.19h1.52v3.05h-1.52Zm-1.52 13.71h1.52v1.53h-1.52ZM18.28 16h1.53v1.52h-1.53Zm-6.09 13.71h7.62v1.53h-7.62Zm0-6.09h7.62v1.52h-7.62Zm4.57-9.15h1.52V16h-1.52Zm-1.52 3.05h3.04v1.53h-3.04Zm0-7.62h1.52v4.57h-1.52ZM12.19.76h7.62v1.52h-7.62Zm-1.53 21.33h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52H9.14Zm0-12.19h1.52v3.05H9.14ZM3.05 29.71h4.57v1.53H3.05Zm0-28.95h4.57v1.52H3.05ZM1.52 28.19h1.53v1.52H1.52Zm0-25.91h1.53v1.53H1.52ZM0 23.62h1.52v4.57H0Zm0-10.67h1.52v6.1H0Zm0-9.14h1.52v4.57H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFaceId
